// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2HCp9","title":"Images45_title__sSSlz","images":"Images45_images__1nG66"};